
import React from "react";
import { useState } from "react";
function ProfileMessage(){
  const [message, setMessege] = useState({
    messages:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Semper lacus dignissim tellus facilisis purus vitae egestas mattis feugiat."
  
  });
    
       
      
      let dataClass=
        {
          position: "relative",
        top:"40px",
       
        left: "4%",
       paddingRight:"40px",
       fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '15px',
      
      color: '#7E7E7E',
        }
      
        
    return(
        <div className="messages-sec">
          
        <div class="linee"><a class="dot" href="">...</a> </div>
      <span className="rmsg">Recent messages</span>  
          <div className="overflow1">
            <div className= "recent-messge">
            <span className="name-letter">M</span> <span className="full-name">Mohit<br></br></span><span className="time">2 minutes ago</span>
  
               <p style={dataClass}> {message.messages}</p>

  
            </div>
            <div className= "recent-messge">
            <span className="name-letter">M</span> <span className="full-name">Mohit<br></br></span><span className="time">2 minutes ago</span>
  
               <p style={dataClass}> {message.messages}</p>

  
            </div>
        
        
  
           
                    
          </div>
          
                      <div class="messages-bottom"><span className="messagess">Message</span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-angle-expand  icon6" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z"/>
  </svg></div>
        </div>
    )
}
export default ProfileMessage